import React from 'react';
import { makeStyles } from '@material-ui/core';

/**
 * Compact horizontal toolbar that hosts a page's search field and action
 * buttons on a single row. Wraps to multiple rows on narrow viewports.
 *
 * Replaces the previous pattern of stacking <SearchBar/> and
 * <ButtonsContainer/> as separate blocks, which wasted vertical space.
 */
export const PageToolbar: React.FC<{
    search?: React.ReactNode;
    actions?: React.ReactNode;
    extras?: React.ReactNode;
}> = ({ search, actions, extras }) => {
    const classes = useStyles();
    return (
        <div className={classes.toolbar}>
            {search && <div className={classes.search}>{search}</div>}
            {extras && <div className={classes.extras}>{extras}</div>}
            {actions && <div className={classes.actions}>{actions}</div>}
        </div>
    );
};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '12px',
        marginTop: '12px',
        marginBottom: '12px',
    },
    search: {
        flex: '1 1 280px',
        minWidth: '220px',
    },
    extras: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        alignItems: 'center',
    },
    actions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        alignItems: 'center',
        marginLeft: 'auto', // pushes actions to the right when there's room
    },
});
